import { Box, Stack, Text } from '@mantine/core';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

/**
 * Visueller Leer-Zustand für Listen und Detailbereiche.
 * Zeigt Icon, Titel, optionale Beschreibung und optionale Aktion.
 */
export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <Stack align="center" gap="sm" py="xl">
      <Box
        className="empty-state-pulse"
        style={{
          color: 'var(--color-primary)',
          opacity: 0.8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 80,
          height: 80,
          marginBottom: 8,
        }}
      >
        <Box style={{ width: 42, height: 42 }}>{icon}</Box>
      </Box>
      <Text fw={600} c="var(--color-text-muted)" size="sm" ta="center">
        {title}
      </Text>
      {description && (
        <Text c="dimmed" size="xs" ta="center" maw={280}>
          {description}
        </Text>
      )}
      {action && <Box mt="xs">{action}</Box>}
    </Stack>
  );
}
